import gql from 'graphql-tag';

const CREATE_SIMULATION_MUTATION = gql`
  mutation(
      $contractId: Int!,
      $calculationTypeKeys: [Int]!,
      $dateClosingFiscalYear: Date!,
      $maritalStateKey: Int!,
      $salaries: [SalaryInput]!,
      $commission: Decimal!,
      $language: String!,
      $calculationDate: Date) {  
    createSimulation(
      contractId: $contractId,
      calculationTypeKeys: $calculationTypeKeys,
      dateClosingFiscalYear: $dateClosingFiscalYear,
      maritalStateKey: $maritalStateKey,
      salaries: $salaries,
      commission: $commission,
      language: $language,
      calculationDate: $calculationDate
    ){
      simulationId
      state
      professionId
      questions{
        questionId
        questionLabel
        questionName
      }

    }
  }
`;

export default CREATE_SIMULATION_MUTATION;
